import React from 'react';
import { useAppSelector } from '../store/hooks';
import { selectModalOnboarding } from '../store/onboardingSlice';
import { selectBaseUrl, selectStageCheckList } from '../store/phonesSlice';
import { GenericUpdateForm } from '../OnboardingViewModal';
import { Checklist } from './OnboardingViewHelpers';
import './PhonesModal.css';

const PhonesModal = () => {
  // Redux state
  const modalOnboarding = useAppSelector(selectModalOnboarding);
  const baseUrl = useAppSelector(selectBaseUrl);
  const stageCheckList = useAppSelector(selectStageCheckList);

  // Get phones data from the onboarding object
  const phones = modalOnboarding?.stages?.phones?.status;

  const formatBoolean = (value) => {
    return value ? 'Completed' : 'No';
  };

  return (
    <div className="space-y-4">
      
      { modalOnboarding && (
        <div>
          <p className={`phones-status${phones ? ' phones-status-active' : ' phones-status-inactive'}`}>{formatBoolean(phones)}</p>
          <GenericUpdateForm onboarding={modalOnboarding} stage="phones" baseUrl={baseUrl} />
          
          {/* Checklist Component */}
          <Checklist 
            stage="phones" 
            onboarding={modalOnboarding} 
            stateCheckList={stageCheckList} 
          />
        </div>
      )}
    </div>
  );
};

export const displayHistoryPhones = (onboarding) => {
  // For now, return a simple table row with placeholder data
  // In the future, this would parse actual history data from the onboarding object
  return (
    <tr className="phones-history-row">
      <td className="phones-history-cell">
        {new Date().toLocaleString()}
      </td>
      <td className="phones-history-cell">
        Not set
      </td>
      <td className="phones-history-cell">
        {onboarding.stages?.phones?.status ? '✅' : '❌'}
      </td>
      <td className="phones-history-cell">
        Initial status
      </td>
    </tr>
  );
};

export { PhonesModal };
